import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '@bibliocommons/base-links';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import { shelfNameShape } from 'app/shapes/search';

import './ShelfLink.scss';

export default function ShelfLink({ userId, shelfName, children, handleClick }) {
  return (
    <Link
      className="cp-shelf-link"
      href={`/v2/users/${userId}/shelves/${shelfName}`}
      handleClick={handleClick}
      dataKey="shelf-link"
    >
      {children}
    </Link>
  );
}

ShelfLink.propTypes = {
  userId: PropTypes.number.isRequired,
  shelfName: shelfNameShape.isRequired,
  children: childrenShape.isRequired,
  handleClick: PropTypes.func
};
